import React, {useEffect, useRef, useState} from "react";
import "./PageLayout.scss";
import MainSidebar from "./MainSidebar.jsx";
import MainHeader from "./MainHeader.jsx";
import {useDispatch, useSelector} from "react-redux";
import {getAccountList, getAccountListSuccess, getAccountMetrics, getPlans, setActiveAccount} from "../../store/reducers/accountSlice.js";
import {useLocation} from "react-router-dom";
import backdrop1 from "../../assets/newIcons/backdrop1.svg";
import backdrop2 from "../../assets/newIcons/backdrop2.svg";
import backdrop3 from "../../assets/newIcons/backdrop3.svg";
import backdrop4 from "../../assets/newIcons/backdrop4.svg";
import backdrop5 from "../../assets/newIcons/backdrop5.svg";
import axios from "axios";
import {baseUrl, getUserAccountListRequest, getUserDetails} from "../../utils/apis/index.js";
import {setUser} from "../../store/reducers/userSlice.js";
import {returnErrors} from "../../store/reducers/error.js";

const PageLayout = ({headerName, children}) => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  const handleMenu = (e) => {
    e.stopPropagation(); // Prevent the click from propagating to the document
    setSidebarStatus((prev) => !prev); // Toggle sidebar state
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPlans({selectedBrand}));
  }, []);

  const defaultData = {
    user_id: 1,
    challenge_id: 4,
    challenge_type: "0",
    unique_id: "0",
    email: "0",
    login_id: null,
    password: "0",
    server: "0",
    name: "0",
    challenge: "0",
    start_date: "0",
    phase: "0",
    trading_platform: "0",
    competition: null,
    is_active: true,
    status: "0",
  };

  useEffect(() => {
    if (idToken) {
      dispatch(getAccountList({idToken, selectedBrand}));
    }
  }, []);

  const idToken = useSelector((state) => state.auth.idToken);
  const activeAccount = useSelector((state) => state?.account?.accountList?.selectedAccount?.login_id?.replace("%23", "#"));
  const selectedAccount = useSelector((state) => state?.account?.accountList?.selectedAccount);
  const firstAccount = useSelector((state) => (state?.account?.accountList?.data && state?.account?.accountList?.data?.length > 0 ? state.account.accountList.data[0] : defaultData));
  const data = selectedAccount || firstAccount;

  useEffect(() => {
    firstAccount && dispatch(getAccountMetrics({idToken, loginId: data?.login_id, trading_platform: data?.trading_platform, email: data?.email}));
  }, [selectedAccount]);
  console.log(data, "datadata");

  const [sidebarStatus, setSidebarStatus] = useState(false);

  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside the sidebar and not on the button
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        // Use classList.contains to check for the specific class
        if (!event.target.classList.contains("menuIconBox") && !event.target.classList.contains("cursorPointer") && !event.target.classList.contains("menu-icon")) {
          setSidebarStatus(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [matches, setMatches] = useState(window.matchMedia("(min-width: 2400px)").matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 2400px)");
    const handleResize = (e) => setMatches(e.matches);

    mediaQuery.addEventListener("change", handleResize);

    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  const location = useLocation();

  useEffect(() => {
    const contentWrapper = document.querySelector(".contentWrapper");
    if (contentWrapper) {
      contentWrapper.scrollTo(0, 0); // Scroll the element to the top
    }
  }, [location.pathname]); // Trigger effect when the path changes

  // AccountList api fetch on crypto edge toggle
  // const fetchAccountListApi = async () => {
  //   let config = {
  //     headers: {Authorization: `Bearer ${idToken}`},
  //     params: {
  //       ...(selectedBrand?.brand === "crypto_edge" ? {crypto: true} : {}),
  //     },
  //   };

  //   //Test
  //   const response = await axios.get(`${baseUrl}/account/list/`, config);
  //   if (response.data) {
  //     dispatch(getAccountList(idToken));
  //     // setIsLoading(false);
  //   }
  // };

  const fetchAccountListApi = async () => {
    try {
      let config = {
        headers: {Authorization: `Bearer ${idToken}`},
        params: selectedBrand?.brand === "crypto_edge" ? {crypto: true} : {},
      };

      const response = await axios.get(`${baseUrl}/account/list/`, config);
      if (response?.data) {
        const accounts = response.data;
        // Set active account if none exists or if the current activeAccount isn't in the list
        if (accounts.length > 0) {
          const activeAccountExists = accounts.some((item) => item?.login_id === activeAccount);
          if (!activeAccount || !activeAccountExists) {
            dispatch(
              setActiveAccount({
                login_id: accounts[0]?.login_id?.replace("%23", "#"),
                trading_platform: accounts[0]?.trading_platform,
                email: accounts[0]?.email,
              }),
            );
          }
        }

        // Dispatch the account list
        dispatch(getAccountListSuccess(accounts));
      }
    } catch (error) {
      console.error("Error fetching account list:", error);
    }
  };

  const fetchProfile = async () => {
    try {
      const res = await getUserDetails(idToken);
      dispatch(setUser(res));
    } catch (error) {
      dispatch(returnErrors("Error fetching user details", 400));
    }
  };

  useEffect(() => {
    fetchProfile();
    selectedBrand?.brand && fetchAccountListApi();
  }, [selectedBrand, idToken, baseUrl, dispatch]);

  return (
    <div className="mainPageLayout">
      <div className="mainPageTopHeader">
        <MainHeader
          matches={matches}
          headerName={headerName}
          showTabs={false}
          mobileMenu={mobileMenu}
          setMobileMenu={setMobileMenu}
          handleMenu={handleMenu}
          sidebarStatus={sidebarStatus}
          setSidebarStatus={setSidebarStatus}
        />
      </div>
      <div
        ref={matches === true ? null : sidebarRef}
        className={`sideBarSection ${sidebarStatus === true ? "activeSidebar" : "inactiveSidebar"}`}
        onMouseLeave={() => setSidebarStatus(false)}
      >
        <MainSidebar
          headerName={headerName}
          mobileMenu={mobileMenu}
          setMobileMenu={setMobileMenu}
        />
      </div>
      <div className={`contentWrapper ${window.location.pathname?.replace(/^\//, "")}`}>
        {selectedBrand?.brand === "crypto_edge" && (
          <>
            <img
              src={backdrop1}
              class="backdrop-svg backdrop-svg-1"
              alt="backdrops"
            />
            <img
              src={backdrop2}
              class="backdrop-svg backdrop-svg-2"
              alt="backdrops"
            />
            <img
              src={backdrop3}
              class="backdrop-svg backdrop-svg-3"
              alt="backdrops"
            />
            <img
              src={backdrop4}
              class="backdrop-svg backdrop-svg-4"
              alt="backdrops"
            />
            <img
              src={backdrop5}
              class="backdrop-svg backdrop-svg-5"
              alt="backdrops"
            />
          </>
        )}
        <div className="contentSection">
          <h2 className="mobileLayoutHeader">{headerName}</h2>
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
